const l10n = text => text;
export default l10n;
